import { createSlice } from "@reduxjs/toolkit";
// Import or define your reporting payload interface
// Replace this with your actual reporting payload structure
import { IReportingPayload } from "packages/lib-utils"; 

export interface ReportingState {
  payload: IReportingPayload | null;
}

const initialState: ReportingState = {
  payload: null,
};

export const ReportingSlice = createSlice({
  name: "Reporting",
  initialState,
  reducers: {
    updateReportingPayload: (state, action) => {
      state.payload = action.payload;
    },
    resetReportingPayload: (state) => {
      state.payload = null;
    },
  },
});

export const { updateReportingPayload, resetReportingPayload } = ReportingSlice.actions;

export default ReportingSlice.reducer;
